export default function VisionHero() {
  return (
    <section className="relative min-h-[75vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ca0bb360810fbd863b41adebc48194b7.jpg"
          alt="持続可能な地域社会"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          地域資源を活かし<br />持続可能な未来をつくる
        </h1>
        <p className="text-xl md:text-2xl font-light leading-relaxed">
          私たちは、地域に眠る可能性を引き出し、<br />
          環境と経済が調和する社会の実現を目指します
        </p>
      </div>
    </section>
  );
}